import ReactDOM from 'react-dom';

const useReactFlushSync = ReactDOM["flushSync".toString()];
function flushSyncFallback(fn) {
  return fn();
}
const flushSync = useReactFlushSync ?? flushSyncFallback;

export { flushSync };
//# sourceMappingURL=flush-sync.mjs.map
